import { Container, Row } from "reactstrap";
import { AlertTitle, BadgesTitle, CheckboxTitle, Inputs, ProgressbarTitle, RadioButtonsTitle, ReactstrapTitle, Select, SwitchTitle, TableComponentsTitle, TooltipTriggersTitle, UIComponentsTitle } from "../../../../../constants";
import { AlertTableData, BadgesTableData, CheckboxTableData, InputTableData, ProgressTableData, RadioBoxTableData, SelectBoxTableData, SwitchTableData, ToolTipTriggersData, UiComponentTableData } from "../../../../../data/formsAndTable/tables/reactstrapTables/TableComponents";
import CommonTableComponent from "./common/CommonTableComponent";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const TableComponentsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TableComponentsTitle} parent={ReactstrapTitle} />
      <Container fluid>
        <Row>
          <CommonTableComponent title={UIComponentsTitle} data={UiComponentTableData} />
          <CommonTableComponent title={AlertTitle} data={AlertTableData} />
          <CommonTableComponent title={ProgressbarTitle} data={ProgressTableData} tableClass="checkbox-td-width" />
          <CommonTableComponent title={CheckboxTitle} data={CheckboxTableData} tableClass="checkbox-td-width" />
          <CommonTableComponent title={RadioButtonsTitle} data={RadioBoxTableData} tableClass="radio-first-col-width" />
          <CommonTableComponent title={Select} data={SelectBoxTableData} tableClass="checkbox-td-width" />
          <CommonTableComponent title={Inputs} data={InputTableData} tableClass="checkbox-td-width" />
          <CommonTableComponent title={BadgesTitle} data={BadgesTableData} />
          <CommonTableComponent title={TooltipTriggersTitle} data={ToolTipTriggersData} />
          <CommonTableComponent title={SwitchTitle} data={SwitchTableData} />
        </Row>
      </Container>
    </>
  );
};
export default TableComponentsContainer;
